/**
 * #1097, #1888: a connection's refusal about what it names (its host, or a database, website,
 * property or site it names), not its sign-in, so the next step is the connection's settings and
 * not a new credential. One rule for the credential email (`runner/notifications/render/
 * credential.ts`) and the badge, the Connections list and the Overview card
 * (`credentialAttentionLabel`), so they say the same words.
 */

interface CheckTarget {
  targetType: string;
  causeCode?: string | null;
}

/** The label of a connection settings refusal, in place of "Credentials refused". */
export const CONNECTION_SETTINGS_REFUSED_LABEL = "Connection settings refused";

/** True for a connection refused with `connection` or `missing_object`. */
export function isConnectionSettingsRefusal(target: CheckTarget): boolean {
  if (target.targetType !== "dataflow") return false;
  return target.causeCode === "connection" || target.causeCode === "missing_object";
}
